export default __webpack_public_path__ + "static/media/less-icon.0678e92e.svg";